import {

    collection,

    onSnapshot,

    query,

    orderBy,
    doc,
    updateDoc

} from "../access/firestore";

import {

    useEffect,

    useState

} from "react";

import {

    db

} from "../firebase";

import {

    useClinic

} from "../context/ClinicContext";

import {

    MessageCircle,

    UserRound

} from "lucide-react";

import MobileChat

    from "./MobileChat";


export default function
MobileWhatsApp(
    props
) {

    const {
        clinicId
    } = useClinic();

    const openConversation = async conversation => {
        setSelectedConversation(conversation);
        if (!Number(conversation.unreadCount)) return;
        try {
            await updateDoc(doc(db, "clinics", clinicId, "whatsappConversations", conversation.id), { unreadCount: 0 });
        } catch (error) {
            console.error("No se pudo actualizar el contador de WhatsApp:", error);
        }
    };


    const [
        conversations,
        setConversations
    ] = useState([]);


    const [
        selectedConversation,
        setSelectedConversation
    ] = useState(
        null
    );


    useEffect(() => {

        if (!clinicId)
            return;


        const q = query(

            collection(
                db,
                "clinics",
                clinicId,
                "whatsappConversations"
            ),

            orderBy(
                "lastMessageAt",
                "desc"
            )

        );


        return onSnapshot(

            q,

            snapshot => {

                setConversations(

                    snapshot.docs.map(
                        doc => ({

                            id:
                                doc.id,

                            ...doc.data()

                        })
                    )

                );

            }

        );

    }, [clinicId]);

    useEffect(() => {
        if (!selectedConversation?.id) return;
        const liveConversation = conversations.find(item => item.id === selectedConversation.id);
        if (liveConversation) setSelectedConversation(liveConversation);
    }, [conversations]);


    if (
        selectedConversation
    ) {

        return (

            <MobileChat

                conversation={
                    selectedConversation
                }

                onBack={
                    () =>
                        setSelectedConversation(
                            null
                        )
                }

                onOpenPatient={
                    props.onSelectPatient
                }

            />

        );

    }


    const obtenerNombre = (
        conversation
    ) => {

        return (

            conversation.patientName

            ||

            conversation.name

            ||

            "Prospecto"

        );

    };


    const obtenerIniciales = (
        nombre
    ) => {

        const partes =
            nombre
                .trim()
                .split(/\s+/);

        if (
            partes.length === 1
        ) {

            return partes[0]
                .slice(0, 2)
                .toUpperCase();

        }

        return (

            partes[0][0] +

            partes[
                partes.length - 1
            ][0]

        ).toUpperCase();

    };


    const card = (

        conversation

    ) => {

        const nombre =
            obtenerNombre(
                conversation
            );

        const tieneNoLeidos =
            conversation.unreadCount > 0;


        return {

            background:
                tieneNoLeidos
                    ?
                    "#f8fbff"
                    :
                    "#ffffff",

            padding:
                "14px 14px",

            borderRadius:20,

            marginBottom:10,

            cursor:"pointer",

            border:
                tieneNoLeidos
                    ?
                    "1px solid #dbeafe"
                    :
                    "1px solid #e8edf3",

            boxShadow:
                tieneNoLeidos
                    ?
                    "0 4px 14px rgba(37,99,235,0.08)"
                    :
                    "0 2px 8px rgba(15,23,42,0.04)",

            transition:
                "transform 0.15s ease, box-shadow 0.15s ease"

        };

    };


    return (

        <div className="vd-mobile-whatsapp"
            style={{
                minHeight:
                    "100vh",

                padding:
                    "18px 16px 110px",

                background:
                    "linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)",

                boxSizing:
                    "border-box"
            }}
        >

            {/* ENCABEZADO */}

            <div
                style={{
                    display:"flex",
                    alignItems:"center",
                    justifyContent:
                        "space-between",

                    marginBottom:22,

                    padding:
                        "4px 2px"
                }}
            >

                <div
                    style={{
                        display:"flex",
                        alignItems:"center",
                        gap:12
                    }}
                >

                    <div
                        style={{
                            width:46,
                            height:46,
                            borderRadius:16,

                            background:
                                "linear-gradient(135deg, #2563eb, #3b82f6)",

                            display:"flex",
                            alignItems:"center",
                            justifyContent:
                                "center",

                            boxShadow:
                                "0 6px 16px rgba(37,99,235,0.20)"
                        }}
                    >

                        <MessageCircle
                            size={24}
                            strokeWidth={2}
                            color="#ffffff"
                        />

                    </div>


                    <div>

                        <div
                            style={{
                                fontSize:23,
                                fontWeight:750,
                                color:"#0f172a",
                                lineHeight:1.15,
                                letterSpacing:
                                    "-0.4px"
                            }}
                        >

                            WhatsApp

                        </div>


                        <div
                            style={{
                                fontSize:13,
                                color:"#64748b",
                                marginTop:4
                            }}
                        >

                            Conversaciones recientes

                        </div>

                    </div>

                </div>


                {

                    conversations.length > 0 && (

                        <div
                            style={{
                                display:"flex",
                                alignItems:"center",
                                gap:6,

                                padding:
                                    "6px 10px",

                                borderRadius:12,

                                background:"#ffffff",

                                border:
                                    "1px solid #e2e8f0",

                                color:"#64748b",

                                fontSize:12,

                                fontWeight:600
                            }}
                        >

                            <MessageCircle
                                size={14}
                                strokeWidth={2}
                            />

                            {

                                conversations.length

                            }

                        </div>

                    )

                }

            </div>


            {/* SIN CONVERSACIONES */}

            {

                conversations.length ===
                0 && (

                    <div
                        style={{
                            background:"#ffffff",

                            border:
                                "1px solid #e2e8f0",

                            borderRadius:22,

                            padding:
                                "42px 24px",

                            textAlign:"center",

                            boxShadow:
                                "0 4px 16px rgba(15,23,42,0.04)"
                        }}
                    >

                        <div
                            style={{
                                width:56,
                                height:56,
                                margin:
                                    "0 auto 14px",

                                borderRadius:18,

                                background:
                                    "#eff6ff",

                                display:"flex",
                                alignItems:"center",
                                justifyContent:
                                    "center"
                            }}
                        >

                            <MessageCircle
                                size={28}
                                strokeWidth={1.8}
                                color="#2563eb"
                            />

                        </div>


                        <div
                            style={{
                                fontSize:15,
                                fontWeight:700,
                                color:"#0f172a"
                            }}
                        >

                            No hay conversaciones

                        </div>


                        <div
                            style={{
                                fontSize:13,
                                color:"#64748b",
                                marginTop:5
                            }}
                        >

                            Las conversaciones de WhatsApp
                            aparecerán aquí.

                        </div>

                    </div>

                )

            }


            {/* CONVERSACIONES */}

            {

                conversations.map(
                    conversation => {

                        const nombre =
                            obtenerNombre(
                                conversation
                            );

                        const iniciales =
                            obtenerIniciales(
                                nombre
                            );

                        const tieneNoLeidos =
                            conversation
                                .unreadCount > 0;


                        return (

                            <div

                                key={
                                    conversation.id
                                }

                                style={
                                    card(
                                        conversation
                                    )
                                }

                                onClick={
                                    () =>
                                        openConversation(
                                            conversation
                                        )
                                }

                            >

                                <div
                                    style={{
                                        display:"flex",
                                        alignItems:
                                            "center",
                                        gap:12
                                    }}
                                >

                                    {/* AVATAR */}

                                    <div
                                        style={{
                                            width:46,
                                            height:46,
                                            borderRadius:16,

                                            background:
                                                tieneNoLeidos
                                                    ?
                                                    "linear-gradient(135deg, #dbeafe, #bfdbfe)"
                                                    :
                                                    "#f1f5f9",

                                            color:
                                                tieneNoLeidos
                                                    ?
                                                    "#2563eb"
                                                    :
                                                    "#64748b",

                                            display:"flex",
                                            alignItems:
                                                "center",
                                            justifyContent:
                                                "center",

                                            fontSize:13,
                                            fontWeight:750,

                                            flexShrink:0
                                        }}
                                    >

                                        {

                                            conversation.patientName

                                                ?

                                                iniciales

                                                :

                                                <UserRound
                                                    size={20}
                                                    strokeWidth={1.8}
                                                />

                                        }

                                    </div>


                                    {/* INFORMACIÓN */}

                                    <div
                                        style={{
                                            minWidth:0,
                                            flex:1
                                        }}
                                    >

                                        <div
                                            style={{
                                                display:"flex",
                                                alignItems:
                                                    "center",
                                                justifyContent:
                                                    "space-between",
                                                gap:8
                                            }}
                                        >

                                            <div
                                                style={{
                                                    minWidth:0,
                                                    fontSize:15,
                                                    fontWeight:
                                                        tieneNoLeidos
                                                            ?
                                                            750
                                                            :
                                                            650,
                                                    color:"#0f172a",
                                                    whiteSpace:
                                                        "nowrap",
                                                    overflow:
                                                        "hidden",
                                                    textOverflow:
                                                        "ellipsis"
                                                }}
                                            >

                                                {nombre}

                                            </div>


                                            {

                                                tieneNoLeidos && (

                                                    <div
                                                        style={{
                                                            minWidth:23,
                                                            height:23,
                                                            padding:
                                                                "0 6px",

                                                            borderRadius:12,

                                                            background:
                                                                "#2563eb",

                                                            color:"#fff",

                                                            display:"flex",
                                                            alignItems:
                                                                "center",
                                                            justifyContent:
                                                                "center",

                                                            fontSize:11,
                                                            fontWeight:750,

                                                            flexShrink:0
                                                        }}
                                                    >

                                                        {
                                                            conversation
                                                                .unreadCount
                                                        }

                                                    </div>

                                                )

                                            }

                                        </div>


                                        <div
                                            style={{
                                                marginTop:5,

                                                fontSize:13,

                                                lineHeight:1.35,

                                                color:
                                                    tieneNoLeidos
                                                        ?
                                                        "#334155"
                                                        :
                                                        "#64748b",

                                                fontWeight:
                                                    tieneNoLeidos
                                                        ?
                                                        500
                                                        :
                                                        400,

                                                whiteSpace:
                                                    "nowrap",

                                                overflow:
                                                    "hidden",

                                                textOverflow:
                                                    "ellipsis"
                                            }}
                                        >

                                            {

                                                conversation
                                                    .lastMessage

                                                ||

                                                "Sin mensajes."

                                            }

                                        </div>

                                    </div>

                                </div>

                            </div>

                        );

                    }

                )

            }

        </div>

    );

}
